export default class TaskQuestion {
  constructor(question) {
    this.name = question.name;
    this.description = question.description;
    this.tag = question.tag;

    this.type = question.type;
    this.sort_order = question.sort_order;

    /** Settings
     * @Settings {
     *  is_text_required: Boolean
     *  is_document_required: Boolean
     *  is_image_required: Boolean
     *  is_link_required: Boolean
     *  is_completely_correct: Boolean
     * }
     */
    this.settings = question.settings;

    /** Option[]
     * @Option {
     *  name: String
     *  parent_id?: Number
     *  is_correct: Boolean
     *  score: Number
     *  penalty_score?: Number
     *  images: { name }[]
     * }
     */
    this.options = question.options || [];

    /** Criteria[]
     * @Criteria {
     *  name: String
     *  min_score: Number
     *  max_score: Number
     * }
     */
    this.criterias = question.criterias || [];
  }
}
